import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useConversations } from '../hooks/useConversations';
import Sidebar from '../components/Sidebar';
import UsersPanel from '../components/UsersPanel';
import './Chat.css';
import './Users.css';

export default function Users() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { conversations, activeId, setActiveId, createConversation, deleteConversation } = useConversations(
    user.id
  );

  const [collapsed, setCollapsed] = useState(() => window.innerWidth < 780);

  function handleSelect(id) {
    setActiveId(id);
    navigate('/');
  }

  function handleCreate() {
    createConversation();
    navigate('/');
  }

  return (
    <div className="chat-screen">
      <Sidebar
        user={user}
        conversations={conversations}
        activeId={activeId}
        onSelect={handleSelect}
        onCreate={handleCreate}
        onDelete={deleteConversation}
        onLogout={logout}
        collapsed={collapsed}
        onToggleCollapse={() => setCollapsed((v) => !v)}
      />

      <div className="chat-main">
        <header className="chat-topbar">
          {collapsed && (
            <button className="icon-btn" onClick={() => setCollapsed(false)} title="Open sidebar">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M4 5H20M4 12H20M4 19H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </button>
          )}
          <button className="icon-btn" onClick={() => navigate('/')} title="Back to chat">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path
                d="M15 6L9 12L15 18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <div className="chat-topbar-title">Users</div>
          {user.userType === 2 && user.entity?.name && (
            <div className="chat-topbar-org">{user.entity.name}</div>
          )}
          <div className="chat-topbar-plan">{user.packageName || 'No plan'}</div>
        </header>

        <div className="chat-scroll">
          <div className="users-page-body">
            <UsersPanel />
          </div>
        </div>
      </div>
    </div>
  );
}
